import * as Types from '../constants/Types';
import { getContentLanguage } from '../utils/commonUtils';

const initialState = {
    isFetching: false,
    contentLanguage: getContentLanguage(),
};

export default (state = initialState, action) => {
    switch (action.type) {
        case Types.CONTENT_LANGUAGE_CHANGE_ACTION:
            return { ...state, isFetching: false };
        case Types.CONTENT_LANGUAGE_CHANGE_SUCCESS:
            return { ...state, isFetching: true, contentLanguage: action.language };
        case Types.SETTING_FAIL:
            return { ...state, isFetching: false };
        default:
            return state;
    }
}
